<template>
    <rkm-overlay>
        <template>
            <rkm-layout-body title="Fila de atendimento">
                <template
                    v-if="additionals && additionals.salaVacinacaoLogada && !!additionals.salaVacinacaoLogada.id"
                    v-slot:actions
                >
                    <rkm-button
                        @click="$refs.ModalRecepcao.open()"
                        authorize="store-imunizacao-fila-atendimento"
                        color="primary"
                    >
                        Adicionar paciente na lista
                    </rkm-button>
                </template>

                <rkm-layout-content>
                    <List @additionals-load="additionals = $event" />
                </rkm-layout-content>

                <ModalRecepcao ref="ModalRecepcao" />
            </rkm-layout-body>
        </template>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/imunizacao/fila-atendimento/List'
import ModalRecepcao from '@/components/imunizacao/fila-atendimento/components/recepcao/Modal'

export default {
    components: {
        List,
        ModalRecepcao,
    },
    data: () => ({
        additionals: null,
    }),
}
</script>